<template>
    <div class="tab-account-setting">
        <div class="blockcont">
            <div class="smalltitle">Continuing Medical Education</div>
            <div class="explain">
                <em>This CME storage function allows you to store CME certificates and calculate number
                    of
                    CME credits in each folder. This folder is also shown at your profile at the
                    clinic(s)
                    you are associated with.</em>
            </div>
            <div class="currentlist">
                <ul class="itemlisttable filelist dcm-list emr-list scroll short2 samebglist"
                    style="height: auto !important; padding-top: 0px !important;">
                    <li class="itemlisthead">
                        <div><input type="checkbox"></div>
                        <div class="foldername" style="width: 60% !important;">
                                <span style="cursor: pointer;" @click="backRoot()">
                                    <i class="fa fa-home mouse" title="Root folder"
                                       style="font-size: 15px !important;"></i>/</span>
                            <span v-if="tempData.nameRoot">{{ tempData.nameRoot }}</span>
                        </div>
                        <div style="width: 10% !important;font-size: 15px !important; text-align: center;">
                            Credit
                        </div>
                        <div style="width: 10% !important;font-size: 15px !important; text-align: center !important;">
                            Date
                        </div>
                        <div style="width: 14% !important; text-align: right !important; font-size: 15px !important;">
                            Size
                        </div>
                        <div class="itemaction"></div>
                    </li>
                    <li v-for="(item, index) in cmeFolders" class="folderitem"
                        v-if="!tempData.nameRoot">
                        <div><input type="checkbox"></div>
                        <div style="width: 60% !important;" @click="showFolder(index)">
                            <div class="filethumb"></div>
                            <div style="width: 86% !important;margin-top: 5px !important;" class="filename"
                                 :title="item.name">{{item.name}}
                            </div>
                        </div>
                        <div @click="showFolder(index)"
                             style="width: 10% !important;padding-top: 5px !important; text-align: center;">
                            {{item.credit}}
                        </div>
                        <div @click="showFolder(index)"
                             style="width: 10% !important; padding-top: 5px !important; text-align: center !important;">
                            {{formatTime(item.last_modified)}}
                        </div>
                        <div @click="showFolder(index)"
                             style="width: 14% !important; text-align: right !important; padding-top: 5px !important;">
                            {{fileSize(item.size)}}
                        </div>
                        <div class="itemaction" style="padding-right: 0px !important; float: right !important;">

                        </div>
                    </li>
                    <li v-if="tempData.nameRoot" v-for="(item, index) in tempData.files"
                        :class="fileIcon(item.mimeType)">
                        <div><input type="checkbox"></div>
                        <div style="width: 60% !important;">
                            <div class="filethumb"></div>
                            <div @click="previewFileCme(item)" style="width: 86% !important;"
                                 class="filename" title="item.name">{{item.file_name}}
                            </div>
                        </div>
                        <div style="width: 10% !important; text-align: center;">{{item.credit}}</div>
                        <div style="width: 10% !important;text-align: center;">{{formatTime(item.created_at)}}</div>
                        <div style="width: 14% !important; text-align: right !important;">
                            {{fileSize(item.file_size)}}
                        </div>
                        <div class="itemaction" style="padding-right: 0px !important; float: right !important;">

                        </div>
                    </li>
                </ul>
            </div>
            <preview-pdf
                    v-if="previewPdf.modal"
                    :linkPreview="previewPdf.link"
                    @updateModal="previewPdf.modal = $event">
            </preview-pdf>
        </div>
    </div>
</template>

<script>
import CommonMixin from '../../../../mixins/general/CommonMixin.vue'
import httpClient from '../../../../client'
import config from '../../../../config'
import PreviewPdf from '../../../../global/PreviewPdf'

export default {
  name: 'TabCme',
  components: { PreviewPdf },
  props: {
    userInfo: {}

  },
  mixins: [CommonMixin],
  data () {
    return {
      tempData: {
        folderId: '',
        nameRoot: '',
        files: []
      },
      cmeFolders: [],
      previewPdf: {
        modal: false,
        link: ''
      }
    }
  },
  computed: {},
  watch: {},
  updated () {
  },
  mounted () {
    this.getListFolder()
  },
  beforeDestroy () {
  },
  methods: {
    previewFileCme (item) {
      this.previewPdf.link = item.link
      this.previewPdf.modal = true
    },
    backRoot () {
      this.tempData.nameRoot = ''
      this.tempData.files = []
    },
    showFolder (index) {
      this.tempData.folderId = this.cmeFolders[index].id
      this.tempData.nameRoot = this.cmeFolders[index].name
      this.tempData.files = this.cmeFolders[index].cme_files
    },
    async getListFolder () {
      try {
        let response = await httpClient.get('/cme/list-folders', { params: { userId: this.userInfo.id } })
        if (response.data.s === 200) {
          this.cmeFolders = response.data.data.folders
          console.log(this.cmeFolders, '22')
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
